export default __webpack_public_path__ + "static/media/epl-banner-cn.50ced2f0.jpg";